import Service from '@ember/service';
import { debug } from '@ember/debug';

export default class ExternalLinkManager extends Service {
  onClick(event) {
    // override in tests to handle external links
    debug('ExternalLinkManager.onClick', event);
  }
}
